// extracted by mini-css-extract-plugin
export default {"bold":"bold__Nc_fTpQuiRDt","create":"create__YvqtXGPvBitC","spaceLeft":"spaceLeft__SilrsmGKSWZG"};